import { useAtom } from 'jotai';
import { useCallback, useMemo } from 'react';
import { atomicStateAtom } from './atomicState.atom';

export const useAtomicState = (screenName: string, componentId: number) => {
  const [stateMap, setStateMap] = useAtom(atomicStateAtom);

  const key = `${screenName}:${componentId}`;

  const params = useMemo(() => stateMap[key] ?? {}, [stateMap, key]);

  const setParam = useCallback(
    (queryName: string, queryValue: string | null) => {
      setStateMap(prev => ({
        ...prev,
        [key]: {
          ...prev[key],
          [queryName]: queryValue,
        },
      }));
    },
    [setStateMap, key],
  );

  const initParams = useCallback(
    (initial: Record<string, string>) => {
      setStateMap(prev => {
        // 이미 값이 있으면 덮어쓰지 않음
        if (prev[key]) return prev;
        return {
          ...prev,
          [key]: initial,
        };
      });
    },
    [setStateMap, key],
  );

  return { params, setParam, initParams };
};
